import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { useDebouncedResizeHandler } from '../hooks/useDebouncedResizeHandler';
import { setAppDimensions } from '../redux/actions/sessionActions';
import { useAppDispatch } from '../redux/store';
/**
 * Measures and stores the current dimensions of the app instance (debounced).
 */
export const AppInstanceDimensionsWrapper = ({ children }) => {
    const dispatch = useAppDispatch();
    const containerRef = useRef(null);
    const handleResize = useCallback(() => {
        if (!containerRef.current) {
            return;
        }
        const { width, height } = containerRef.current.getBoundingClientRect();
        dispatch(setAppDimensions({ w: width, h: height }));
    }, [dispatch]);
    useEffect(() => {
        handleResize();
    }, [handleResize]);
    useDebouncedResizeHandler(handleResize);
    return _jsx("div", { ref: containerRef, children: children });
};
